export enum InsuranceType {
    GENERAL_LIABILITY = 'GENERAL_LIABILITY',
    PROFESSIONAL_LIABILITY = 'PROFESSIONAL_LIABILITY',
    WORKERS_COMPENSATION = 'WORKERS_COMPENSATION',
    DISABILITY = 'DISABILITY',
}
